import api from '@edu-fe/api'

const module = {
  name: 'share',
  info: (courseId, chapterId, wpsSid, userId, shareMark) => {
    return api.create(`/course/share?courseId=${courseId}&chapterId=${chapterId}&client=2&userId=${wpsSid}${shareMark ? `&shareMark=${shareMark}` : ``}`)
  }
}

export default module
